exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".style__price___1JOeb{text-align:right;margin:0 auto}.style__name___KL3Jn,.style__price___1JOeb{font-size:14px;padding:5px 0}.style__total___1Hs4D{color:#c1887f}.style__grandTotal___3kkd7{font-family:Poppins-Medium;font-size:24px;font-weight:500}", ""]);

// exports
exports.locals = {
	"price": "style__price___1JOeb",
	"name": "style__name___KL3Jn",
	"total": "style__total___1Hs4D",
	"grandTotal": "style__grandTotal___3kkd7"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[name]__[local]___[hash:base64:5]!./src/components/order-line/style.css
// module id = 701
// module chunks = 0